import authRoutes from "./authRoutes";
import appRoutes from "./appRoutes";
import designationRoutes from "./designationRoutes";
import { adminDashboardRoutes, adminAuthRoutes } from "./adminRoutes";

const routes = [
  authRoutes,
  appRoutes,
  adminDashboardRoutes,
  adminAuthRoutes,
  designationRoutes,
];

export { routes };
